class Service {
  downloadBlob(blob, fileName) {
    let a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';

    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = fileName || 'excel.xsls';
    a.click();
    window.URL.revokeObjectURL(url);
  }

  getFileNameFromContentDispositionHeader(value) {
    const regex = /.*filename="?([^;"]+)"?;.*/m;
    const match = regex.exec(value);
    if (!match) return undefined;
    return match[1];
  }
}

export const DownloadBlobService = new Service();



// WEBPACK FOOTER //
// ./src/lib/services/downloadBlob.js